import { cva } from "class-variance-authority";

export const simpleFooterBg = cva("py-[16px]", {
  variants: {
    theme: {
      light: "bg-light-background",
      dark: "bg-dark-background"
    }
  }
});

export const simpleTextColor = cva("text-[12px] leading-[18px]", {
  variants: {
    theme: {
      light: "text-light-label",
      dark: "text-dark-label"
    }
  }
});

export const simpleTextLine = cva("h-[12px] w-[1px] mx-[8px]", {
  variants: {
    theme: {
      light: "bg-light-line-primary",
      dark: "bg-dark-line-primary"
    }
  }
});

export const footerBg = cva("px-[20px] md:!px-[60px] py-[20px] md:pb-[120px] md:pt-[90px]", {
  variants: {
    theme: {
      light: "bg-light-background",
      dark: "bg-dark-background"
    }
  }
});

export const footerContainerStyle = cva("flex flex-col items-center justify-center", {
  variants: {
    theme: {
      light: "text-light-label-60",
      dark: "text-dark-label-60"
    },
    size: {
      "1280": "max-w-screen-xl",
      "1440": "max-w-[1440px]"
    },
    defaultVariants: {
      size: "1280",
      theme: "light"
    }
  }
});

export const infoColor = cva("", {
  variants: {
    theme: {
      light: "text-light-label-40",
      dark: "text-dark-label-40"
    }
  }
});

export const LabelColor = cva("", {
  variants: {
    theme: {
      light: "text-light-label-60",
      dark: "text-dark-label-60"
    }
  }
});

export const TitleColor = cva("", {
  variants: {
    theme: {
      light: "text-black",
      dark: "text-white"
    }
  }
});

export const LogoStyle = cva("", {
  variants: {
    theme: {
      light: "text-light-label",
      dark: "text-dark-primary"
    }
  }
});

export const TextColor = cva("text-[12px]", {
  variants: {
    theme: {
      light: "text-light-label",
      dark: "text-dark-label"
    }
  }
});

export const IconStyle = cva("w-[24px] h-[24px] cursor-pointer hover:text-base-primary", {
  variants: {
    theme: {
      light: "text-light-label-40",
      dark: "text-dark-label-40"
    }
  }
});

export const PopoverBgStyles = cva("", {
  variants: {
    theme: {
      light: "bg-light-fill-primary",
      dark: "bg-dark-fill-primary"
    }
  }
});

export const PopoverHoverStyle = cva("", {
  variants: {
    theme: {
      light: "hover:text-light-label hover:bg-light-fill-secondary",
      dark: "hover:text-dark-label hover:bg-dark-fill-secondary"
    }
  }
});

export const WrapperStyles = cva("hidden md:block w-full border-b-[1px] ", {
  variants: {
    theme: {
      light: "border-b-light-line-primary",
      dark: "border-b-dark-line-primary"
    }
  }
});
